module.exports = __webpack_public_path__ + "images/1aecf4b.png";